import { useState } from 'react';

import { Button } from '@common/ui/buttons/Button';
import { Disclaimer } from '@common/ui/Disclaimer';
import { useEventEmit } from '@common/utils/events';

import { isAccount, useAccountStore } from '@entities/account';

import { usePatchMeSettings } from '@services/hooks/AccountService';

/**
 * «Анкета скрыта» at the top of the Profile tab while the user hides their
 * profile. «Показать» turns hiding off with PATCH /me/settings.
 */
export const HiddenNotice = () => {
  const emit = useEventEmit();
  const { trigger: triggerPatchMeSettings } = usePatchMeSettings();
  const [isShowing, setIsShowing] = useState(false);

  const showProfile = async () => {
    if (isShowing) return;

    setIsShowing(true);

    try {
      const settings: unknown = await triggerPatchMeSettings({
        hidden: false,
      });

      // A malformed answer is a failed request: the notice stays.
      if (!isAccount(settings)) {
        throw new Error('PATCH /me/settings answered without settings');
      }

      const { account, setAccount } = useAccountStore.getState();

      setAccount({
        ...(account ?? settings),
        hidden: settings.hidden,
        features: settings.features,
      });
    } catch {
      emit('error', {
        title: 'Не удалось показать анкету',
        description: 'Попробуйте ещё раз',
      });
    } finally {
      setIsShowing(false);
    }
  };

  return (
    <div data-test-id="hidden-notice" style={{ margin: '0 16px' }}>
      <Disclaimer
        type="warning"
        closable={false}
        title="Анкета скрыта"
        body="Её не видят в ленте и свахи"
        buttons={
          <Button
            testId="hidden-notice-show-button"
            size={400}
            loading={isShowing}
            disabled={isShowing}
            onClick={() => void showProfile()}
          >
            Показать
          </Button>
        }
      />
    </div>
  );
};
